import { useState } from 'react';
import Screen from '../../components/layout/Screen';
import { useNavigate } from 'react-router';
import { ICONS } from '../../common/icons/icons';
import BooksAddScreen from './BooksAddScreen';
import { ListApiInfinite } from '../../components/List';
import BooksService from '../../common/API/BooksService';
import SectionTitle from '../../components/SectionTitle';
import { GoTrash } from 'react-icons/go';
import useForceRefetch from '@/common/hooks/useForceRefetch';
import { useDialog } from '@/common/hooks/useDialog';
import BookPlaceholder from '@/components/BookPlaceholder';
import { Button } from '@/components/ui/button';

const BooksListScreen = () => {
  const [search, setSearch] = useState('');
  const { shouldRefetch, forceRefetch } = useForceRefetch();
  const { showConfirmDialog, hideConfirmDialog, openDrawer, closeDrawer } = useDialog();
  const navigate = useNavigate();

  const onDelete = (id: number) => {
    showConfirmDialog({
      title: 'Delete item',
      description: 'Are you sure you want to delete this item?',
      buttons: [
        {
          title: 'Confirm',
          onClick: () => {
            BooksService.delete(id).then((res) => {
              forceRefetch();
              hideConfirmDialog();
            });
          },
          color: 'primary',
        },
        {
          title: 'Cancel',
          color: 'neutral',
          variant: 'link',
          closesModal: true,
        },
      ],
    });
  };

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        header: {
          title: 'Books',
          backBtnLabel: 'Home',
          backBtnUrl: '/home',
          titleClassName: 'text-white',
          rightContent: (
            <Button
              variant='ghost'
              size='icon'
              onClick={() => {
                navigate('/books/add');
              }}
            >
              {ICONS.plus}
            </Button>
          ),
        },
      }}
    >
      <ListApiInfinite<any>
        onSearch={setSearch}
        queryKey={['authors', search, shouldRefetch]}
        queryFn={({ pageParam }) =>
          BooksService.all({
            page: pageParam,
            search,
            per_page: 20,
          })
        }
        containerClassName='h-full px-4'
        listClassName='grid grid-cols-2 gap-4 !bg-transparent'
        renderItem={(item, i) => {
          return (
            <div
              onClick={() => {
                navigate(`/books/${item.id}`);
              }}
              className='col-span-1 w-full'
              key={item.id}
            >
              <div className='w-full relative bg-card rounded-lg'>
                <div className='h-[200px] w-full  rounded-lg'>
                  {item?.image ? (
                    <img
                      src={item?.image?.url}
                      className='rounded-t-lg object-center object-cover w-full h-full'
                      alt=''
                    />
                  ) : (
                    <BookPlaceholder />
                  )}
                </div>

                <div className=''>
                  <h3 className='text-white  font-medium text-sm p-2'>{item?.name}</h3>
                  <div className='w-full h-[1px] border border-neutral-800 border-dashed'></div>
                  <span className='text-xs text-white/40 p-2 block'>{item?.author?.name}</span>
                </div>
                <div
                  className='absolute top-0 right-0 w-8 h-8 flex items-center justify-center bg-card rounded-bl-lg rounded-tr-lg'
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onDelete(item.id);
                  }}
                >
                  <GoTrash className='text-red-500 ml-1 mb-1 text-sm' />
                </div>
              </div>
            </div>
          );
        }}
        header={<SectionTitle className='text-white' label='Books' />}
      />
    </Screen>
  );
};

export default BooksListScreen;
